import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "", "data-test": "boas-vindas" } },
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [_c(VSpacer)],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("v-card-widget", { attrs: { "enable-header": false } }, [
                _c(
                  "div",
                  {
                    staticClass: "pb-10 ma-8",
                    attrs: { slot: "widget-content" },
                    slot: "widget-content",
                  },
                  [
                    _c(VRow, [
                      _c("h1", { staticClass: "title mb-4 primary--text" }, [
                        _vm._v("Olá! Seja bem-vindo(a)!"),
                      ]),
                    ]),
                    _c(VRow, [
                      _c("p", { staticClass: "text-justify" }, [
                        _vm._v(
                          " O sistema Desenvolva é uma ferramenta tecnológica que tem por objetivo facilitar a implantação do Programa de Gestão por Competências na Universidade Federal do Ceará. "
                        ),
                      ]),
                      _c("p", { staticClass: "text-justify" }, [
                        _vm._v(
                          " A Gestão por Competências é um modelo de gestão de pessoas inovador e estratégico que formaliza o permanente desenvolvimento de competências técnicas e comportamentais das pessoas, visando o alcance dos objetivos institucionais. "
                        ),
                      ]),
                      _c("p", { staticClass: "text-justify" }, [
                        _vm._v(
                          " Nos ícones abaixo você terá acesso aos módulos do sistema. "
                        ),
                      ]),
                    ]),
                    _vm._l(_vm.linhas, function (linha, index) {
                      return _c(
                        VRow,
                        { key: index, staticClass: "justify-center" },
                        _vm._l(linha, function (botao) {
                          return _c(
                            VCol,
                            {
                              key: botao.link,
                              staticClass: "d-flex col-md-auto justify-center",
                            },
                            [
                              _c(
                                VBtn,
                                {
                                  class: { "disable-events": botao.disabled },
                                  attrs: {
                                    color: botao.disabled
                                      ? "grey"
                                      : "secondary",
                                    elevation: "3",
                                    outlined: "",
                                    "x-large": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.to(botao.link)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    VIcon,
                                    { attrs: { left: "", size: "24" } },
                                    [_vm._v(" " + _vm._s(botao.icon) + " ")]
                                  ),
                                  _c("span", [_vm._v(_vm._s(botao.nome))]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }